"use client"
import { useUpdate } from '@/core/hooks/use-update.hook';
import AuthRepo from '@/core/repos/auth.repo';
import ConfigRepo from '@/core/repos/config.repo';
import container from '@/lib/di/container';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router';

const authRepo = container.get(AuthRepo);
const configRepo = container.get(ConfigRepo);

const AuthProvider: React.FC = ({}) => {
    const navigate = useNavigate();
    const authState = authRepo.useAuth();
    const {pathname} = useLocation();
    //componentDidMount equivalent, run exclusively on client-side
    useEffect(() => {
        authRepo.registerInterceptor();
        if (localStorage.getItem('ACCESS_TOKEN')) {
            authRepo.authSubject.next(true);
            authRepo.getUserData();
            authRepo.getUserClaims();
        } else {
            authRepo.authSubject.next(false);
            if (pathname != '/login') {
                navigate('/login', {replace: true});
            }
        }

    }, []);

    useUpdate(() => {
        if (!authState) {
            navigate('/login', {replace: true});
        } else {
            if (pathname === '/login') {
                navigate('/', {replace: true});
            }
        }
    }, [authState]);
    return (<></>)
}

export default AuthProvider;